<ng-container *ngIf = "subscriptionPlan == 'subscrybe-premium'">
<div class = "breakdown-check">
	<button (click)="getDashboard()" id = "update-btn" class="btn btn-outline-primary">
		Back to Dashboard
	</button>
</div>
<div *ngIf = "showChart" class = "breakdown-content">
	<div class = "my-spending">
		<h2>My Spending</h2>
			<ng-container *ngIf = "monthlySpending == 0">
				You have no subscriptions, once you add subscriptions you will be able to see your upcoming renewals
			</ng-container>

			<ng-container *ngIf = "monthlySpending != 0">
			<p style = "text-align: right;">Chart View: <i placement="top" ngbTooltip="Pie Chart" (click)="changeChart('pie')" id = "{{getChart('pie')}}" class="fas fa-chart-pie"></i>&nbsp;<i placement="top" ngbTooltip="Doughnut Chart" (click)="changeChart('doughnut')" id = "{{getChart('doughnut')}}" class="fas fa-circle-notch"></i></p>
			<div *ngIf = "showChart" style = "width:600px;" class="chart-wrapper">
				<canvas baseChart 
				[data]="doughnutChartData"
				[labels]="doughnutChartLabels"
				[chartType]="doughnutChartType">
			  </canvas>
			</div>
		<p style = "font-size:1.2em;">Monthly Spending: <strong>${{monthlySpending}}</strong></p>
	</ng-container>
		<div class = "most-expensive">
			<h2>Most Expensive</h2>

			<ng-container *ngIf = "!mostExpensive">
				You have no subscriptions, once you add subscriptions you will be able to see your upcoming renewals
			</ng-container>

			<ng-container *ngIf = "mostExpensive">
			<div class = "card" style="width: 25rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
				<div style = "margin:0;text-align: center;" class = "inner-card">
					<div class = "subscription">
						<img style = "height:40px;" src = "https://logo.clearbit.com/{{mostExpensive.subscription_url}}">
						<p><strong>{{mostExpensive.subscription_name}}</strong></p>
					</div>

					<div class = "details">
						<p>Price: <strong>{{mostExpensive.price}}  /{{mostExpensive.payment_sched.slice(0,mostExpensive.payment_sched.length-2)}}</strong></p>
						<p>Next Bill: <strong>{{formattedDate(mostExpensive.next_bill)}}</strong></p>
					</div>
				</div>
			</div>

			<div class = "card" style="width: 25rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
				<div style = "margin:0;text-align: center;padding:0;" class="card-body">
					<h5>Alternatives</h5>
					<div class = "alternative-list">
						<ng-container *ngFor = "let alternative of mostExpensive.alternatives">
								<div class = "alternative">
										<img style = "height:40px;" src = "{{getImage(alternative.url)}}">
										<p><strong>{{alternative.name}}</strong></p>
										<p>{{alternative.price}}</p>
									</div>
						</ng-container>

						<ng-container *ngIf = "mostExpensive.alternatives.length == 0">
							<p>Couldn't find any alternatives, you already have the best deal!</p>
						</ng-container>
					</div>
				</div>
		</div>
	</ng-container>
		</div>
	</div>

	<!-- <div class = "most-expensive">
		<h2>Most Expensive</h2>
		<div class = "card" style="width: 18rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
				<div style = "margin:0;text-align: initial;" class="card-body">
						<div [ngStyle] = "getColor(mostExpensive['subscription_url'])" class = "box">
						</div>
						<h5 class="card-title">{{mostExpensive['subscription_name']}}</h5>
						<p class = "text-muted">{{mostExpensive.price}}  /{{mostExpensive.payment_sched.slice(0,mostExpensive.payment_sched.length-2)}}</p>
						<p class = "text-muted" style = "margin-top:-15px;">Next Bill: {{formattedDate(mostExpensive.next_bill)}}</p>
				</div>
		</div>
		<div class = "card" style="width: 25rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
				<div style = "margin:0;text-align: center;" class="card-body">
					<h5>Alternatives</h5>
					<div class = "alternative-list">
						<ng-container *ngFor = "let alternative of mostExpensive.alternatives">
								<div class = "alternative">
										<img style = "height:40px;" src = "{{getImage(alternative.url)}}">
										<p><strong>{{alternative.name}}</strong></p>
										<p>{{alternative.price}}</p>
									</div>
						</ng-container>
					</div>
				</div>
		</div>
	</div> -->

	<div class = "upcoming-renewal">
		<h2>Upcoming Renewal</h2>
		<ng-container *ngIf = "!upcomingRenewal">
			You have no subscriptions, once you add subscriptions you will be able to see your upcoming renewals
		</ng-container>

		<ng-container *ngIf = "upcomingRenewal">
		<div class = "card" style="width: 18rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
				<div style = "margin:0;text-align: initial;" class="card-body">
						<div [ngStyle] = "getColor(upcomingRenewal['subscription_url'])" class = "box">
						</div>
						<h5 class="card-title">{{upcomingRenewal['subscription_name']}}</h5>
						<p class = "text-muted">{{upcomingRenewal.price}}  /{{upcomingRenewal.payment_sched.slice(0,upcomingRenewal.payment_sched.length-2)}}</p>
						<p class = "text-muted" style = "margin-top:-15px;">Next Bill: {{formattedDate(upcomingRenewal.next_bill)}}</p>
				</div>
		</div>
		<div class = "card" style="width: 25rem;box-shadow: 0px 15px 30px rgb(64,75,99,0.2) !important;border-radius: 25px;">
				<div style = "margin:0;text-align: center;overflow:scroll;" class="card-body">
						<h5>Alternatives</h5>
						<div  class = "alternative-list">
							<div *ngFor = "let alternative of upcomingRenewal.alternatives" class = "alternative">
								<img style = "height:40px;" src = "{{getImage(alternative.url)}}">
								<p><strong>{{alternative.name}}</strong></p>
								<p>{{alternative.price}}</p>
							</div>
						</div>
						<ng-container *ngIf = "!upcomingRenewal.alternatives">
							<p>Couldn't find any alternatives, you already have the best deal!</p>
						</ng-container>
					</div>
		</div>
	</ng-container>
	</div>

</div>

<div class ="loading-screen" *ngIf = "!showChart">
	<h1>Loading Details</h1>
	<div style = "width:200px;height:200px;color:#6E1FD2;" class="spinner-border spinner-border-sm" role="status">
		<!-- <span class="sr-only">Loading...</span> -->
	</div>
</div>

</ng-container>
